var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArt02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 195.4",
    style: {
      enableBackground: "new 0 0 1920 195.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1025.1,82.7C431,217.7,227.5,162.9,0,132.8l0,152l0,110.7h1920V284.7V13.2C1920,13.2,1586.8-45,1025.1,82.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArt02);
export default __webpack_public_path__ + "static/media/art02.fca1c0295068a2d78e0e78c33ce1c3df.svg";
export { ForwardRef as ReactComponent };